import React from 'react';
import LayoutTheme from '@common/Layout/LayoutTheme/LayoutTheme';
import GraphqlProvider from '@common/Providers/GraphqlProvider';
import IntlProvider from '@common/Providers/IntlProvider';
import UserProvider from '@common/Providers/UserProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { env } from 'env.mjs';

import LayoutConfig from '../Layout/LayoutConfig/LayoutConfig';

type ProviderProps = { children: React.ReactElement };

const Providers = ({ children, ...pageProps }: ProviderProps) => {
  const googleClientId = env.NEXT_PUBLIC_GOOGLE_CLIENT_ID;

  return (
    <IntlProvider>
      <GoogleOAuthProvider clientId={googleClientId}>
        <GraphqlProvider {...pageProps}>
          <UserProvider>
            <LayoutConfig>
              <LayoutTheme>{children}</LayoutTheme>
            </LayoutConfig>
          </UserProvider>
        </GraphqlProvider>
      </GoogleOAuthProvider>
    </IntlProvider>
  );
};

export default Providers;
